import { combineReducers } from '@ngrx/store';
import * as fromProducts from './adt-reducers/products.reducer';
import * as fromAdtSpecificationForm from './adt-reducers/adt-specification-form.reducer';
import * as fromContracts from './adt-reducers/contracts.reducer';
import * as fromUnits from './adt-reducers/units.reducer';
import * as fromPaymentTerms from './adt-reducers/payment-terms.reducer';
import * as fromQuantity from './adt-reducers/quantity.reducer';
import * as fromHolidays from './adt-reducers/holidays.reducer';
import * as fromOrderConfirmation from './adt-reducers/order-confirmation.reducer';
import * as fromLeadTimes from './adt-reducers/lead-times.reducer';

/**
 * Interface of all the States used for Admixture order creation
 */
export interface ADTSpecificationState {
  productsState: fromProducts.ProductsState;
  adtSpecificationForm: fromAdtSpecificationForm.AdtSpecificationFormState;
  contractsState: fromContracts.ContractsState;
  unitsState: fromUnits.AdtUnitsState;
  paymentTermsState: fromPaymentTerms.PaymentTermsState;
  quantityState: fromQuantity.AdtQuantityState;
  holidaysState: fromHolidays.HolidaysState;
  orderConfirmationState: fromOrderConfirmation.OrderConfirmationULState;
  leadTimesState: fromLeadTimes.LeadTimesState;
}

/**
 * Admixture reducer combinaded
 */
export const adtReducers = combineReducers({
  productsState: fromProducts.adtProductsReducer,
  adtSpecificationForm: fromAdtSpecificationForm.adtSpecificationFormReducer,
  contractsState: fromContracts.adtContractsReducer,
  unitsState: fromUnits.adtUnitsReducer,
  paymentTermsState: fromPaymentTerms.adtPaymentTermsReducer,
  quantityState: fromQuantity.adtQuantityReducer,
  holidaysState: fromHolidays.adtHolidaysReducer,
  orderConfirmationState: fromOrderConfirmation.orderConfirmationULReducer,
  leadTimesState: fromLeadTimes.adtLeadTimesReducer,
});
